import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Stack,
  Box,
  Typography,
  Button,
} from '@mui/material';
import Iconify from '../common/iconify.component';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ComposeEmailPreview = ({ title, data, onCancel }) => (
  <Dialog
    open
    onClose={() => onCancel()}
    aria-labelledby="compose-email-preview-title"
    aria-describedby="compose-email-preview-description"
    TransitionComponent={Transition}
    fullWidth
    maxWidth="sm"
    PaperProps={{
      sx: { borderRadius: 2 },
    }}
  >
    <DialogTitle id="compose-email-preview-title">{title}</DialogTitle>
    <IconButton
      aria-label="close"
      onClick={onCancel}
      size="small"
      sx={{
        position: 'absolute',
        right: 10,
        top: 15,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <Iconify icon="ic:outline-close" />
    </IconButton>

    <DialogContent dividers sx={{ pt: 0 }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="caption" color="text.secondary">
            From:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {data.fromName} &lt;{data.fromEmail}&gt;
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" color="text.secondary">
            Subject:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {data.subject || '—'}
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            sx={{ mb: 1 }}
          >
            Message:
          </Typography>
          <Box
            sx={{
              p: 2,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              bgcolor: 'background.neutral',
              minHeight: 120,
              '& p': { margin: 0 },
            }}
            dangerouslySetInnerHTML={{ __html: data.message || '—' }}
          />
        </Box>

        <Stack direction="row" justifyContent="flex-end" sx={{ pt: 1 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => onCancel()}
          >
            Close
          </Button>
        </Stack>
      </Stack>
    </DialogContent>
  </Dialog>
);

ComposeEmailPreview.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ComposeEmailPreview;
